import { Grid, Typography } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { OpeningHoursSectionStyles } from '..';
import { useTranslation } from 'react-i18next';

export const OpeningHoursSectionTableHeader = () => {
  const { classes } = OpeningHoursSectionStyles();
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid
        data-testid="opening-hours-section-header"
        container
        className={classNames(classes.headerWrapper, classes.hasBottomBorder)}
      >
        <Grid container md={3} alignSelf="end" alignItems="self-start">
          <Grid alignItems="center" container>
            <Grid className={classes.dayHeader} />
            <Typography className={classes.headerTitle}>{t('app.date')}</Typography>
          </Grid>
        </Grid>
        <Grid container md={1} alignSelf="end" alignItems="self-start" justifyContent="center">
          <Typography className={classes.headerTitle}>{t('app.open')}</Typography>
        </Grid>
        <Grid item md={5} alignItems="self-start" alignSelf="end">
          <Typography className={classes.headerTitle} textAlign="center">
            {t('settings.title.openingHours')}
          </Typography>
        </Grid>
        <Grid item md={3} />
      </Grid>
    </Grid>
  );
};
